var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListToDoTasksChecklistStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "List-To-Do-Tasks-Checklist--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    List To Do Tasks Checklist Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-to-do-tasks-checklist--list-to-do-tasks-checklist-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.461779928571431 31.91705485714286h20.2273725",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.461779928571431 5.347151914285715h20.2273725",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.586145871428572 18.632182971428573H35.81357142857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.3264285714285715 32.809476000000004 2.9142431571428573 3.0051565714285715c1.3713414428571429 -3.939227571428572 2.513396442857143 -5.667829285714285 5.099932157142858 -8.014016142857145",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.3264285714285715 6.327515271428572 2.9142431571428573 3.005315742857143c1.3713414428571429 -3.9392541000000003 2.513396442857143 -5.667855814285715 5.099932157142858 -8.014175314285716",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.450375362857143 19.568482371428573 4.364613214285715 22.573798114285715c1.3713414428571429 -3.9392541000000003 2.513396442857143 -5.667855814285715 5.099932157142858 -8.014175314285716",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListToDoTasksChecklistStreamlineFlex);
export default __webpack_public_path__ + "static/media/List-To-Do-Tasks-Checklist--Streamline-Flex.85d20fd0206e7c952a7a03b43d61dc9f.svg";
export { ForwardRef as ReactComponent };